"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _extends2 = require("babel-runtime/helpers/extends");

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = require("babel-runtime/core-js/object/get-prototype-of");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require("babel-runtime/helpers/possibleConstructorReturn");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require("babel-runtime/helpers/inherits");

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _ValidationError = require("./ValidationError");

var _ValidationError2 = _interopRequireDefault(_ValidationError);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Textarea = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(Textarea, _Component);

  function Textarea() {
    (0, _classCallCheck3.default)(this, Textarea);
    return (0, _possibleConstructorReturn3.default)(this, (Textarea.__proto__ || (0, _getPrototypeOf2.default)(Textarea)).apply(this, arguments));
  }

  (0, _createClass3.default)(Textarea, [{
    key: "render",
    value: function render() {
      var _props = this.props,
          id = _props.id,
          type = _props.type,
          fieldProps = _props.fieldProps,
          small = _props.small;

      var hasError = fieldProps.touched && fieldProps.error;
      var formGroupClasses = "form-group";
      if (hasError) {
        formGroupClasses += " has-error";
      }
      if (small) {
        formGroupClasses += "form-group-small";
      }
      return _react2.default.createElement(
        "div",
        { className: formGroupClasses },
        this.renderLabel(),
        _react2.default.createElement("textarea", (0, _extends3.default)({ id: id, type: type }, fieldProps)),
        _react2.default.createElement(_ValidationError2.default, { fieldProps: this.props.fieldProps }),
        this.props.children
      );
    }
  }, {
    key: "renderLabel",
    value: function renderLabel() {
      var _props2 = this.props,
          id = _props2.id,
          label = _props2.label,
          subLabel = _props2.subLabel;


      if (subLabel) {
        return _react2.default.createElement(
          "label",
          { htmlFor: id },
          label,
          ": ",
          _react2.default.createElement(
            "span",
            { className: "small" },
            subLabel
          )
        );
      }
      return _react2.default.createElement(
        "label",
        { htmlFor: id },
        label,
        ":"
      );
    }
  }]);
  return Textarea;
}(_react.Component), _class.propTypes = {
  id: _react.PropTypes.string.isRequired,
  type: _react.PropTypes.string.isRequired,
  label: _react.PropTypes.string,
  small: _react.PropTypes.bool,
  subLabel: _react.PropTypes.string,
  fieldProps: _react.PropTypes.object.isRequired,
  children: _react.PropTypes.object
}, _temp);
exports.default = Textarea;
module.exports = exports["default"];


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/form/Textarea.js
 ** module id = 307
 ** module chunks = 0
 **/